import { css } from 'styled-components'

const sizes = {
  mobileS: 330,
  mobileM: 375,
  mobileL: 425,
  tabletS: 657,
  tablet: 768,
  laptop: 1024,
  laptopM: 1280,
  laptopL: 1440,
  laptopXL: 1920,
  fourK: 2560,
}

export default Object.keys(sizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${sizes[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})
